module.exports = __webpack_public_path__ + "static/BigLogoBlack-158beed4f1a2367853dc71584c7122d6.svg";